import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./about-article-section.module.css";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { StockStatus } from "./StockStatus/StockStatus";
import { NextDelivery } from "./NextDelivery/NextDelivery";
import { SupplierNumber } from "./SupplierNumber/SupplierNumber";
import { DateStamp } from "./DateStamp/DateStamp";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { SalesLocationsAndStock } from "@coworker/apprestructured/src/shared/components/SalesLocationsAndStock/SalesLocationsAndStock";
interface AboutArticleSectionProps {
  itemNoAndType: ItemNoAndType;
  hfb?: string;
}

export const AboutArticleSection = ({
  itemNoAndType,
  hfb,
}: AboutArticleSectionProps) => {
  return (
    <>
      <div className={styles["about-article-title"]}>
        <FixaText textStyle="Body.S">About article</FixaText>
      </div>
      <FixaListView id="about-article-list">
        <SalesLocationsAndStock itemNoAndType={itemNoAndType} />
        <StockStatus itemNoAndType={itemNoAndType} hfb={hfb} />
        <NextDelivery itemNo={itemNoAndType.no} />
        <SupplierNumber />
        <DateStamp />
      </FixaListView>
    </>
  );
};
